import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { DEFAULT_ANIMATION_DURATION_SECONDS, DEFAULT_CONTAINER_CLASS_NAME, HORIZONTAL_DIRECTION, VERTICAL_DIRECTION } from './ContinuousScroll.constants';
import { getInnerContainerStyle } from './ContinuousScroll.utils';
import ContinuousScrollItem from './components/ContinuousScrollItem';
import { classNames } from '../../../../utils/classname';
import { isComponentNull } from '../../../foundation/services/components';
import { ChildrenPropType } from '../../../foundation/types/component';
import './ContinuousScroll.css';
var defaultProps = {
  animationDuration: DEFAULT_ANIMATION_DURATION_SECONDS,
  className: '',
  direction: HORIZONTAL_DIRECTION
};
export default function ContinuousScroll(_ref) {
  var _classNames;
  var children = _ref.children,
    animationDuration = _ref.animationDuration,
    className = _ref.className,
    direction = _ref.direction;
  if (isComponentNull(children)) {
    return null;
  }
  var containerClassName = classNames((_classNames = {}, _defineProperty(_classNames, DEFAULT_CONTAINER_CLASS_NAME, true), _defineProperty(_classNames, className, true), _defineProperty(_classNames, direction, true), _classNames));
  var innerContainerStyle = getInnerContainerStyle({
    animationDuration: animationDuration,
    direction: direction
  });
  return /*#__PURE__*/React.createElement("div", {
    className: containerClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: "continuous-scroll-inner-container",
    style: innerContainerStyle
  }, children, children, children));
}
ContinuousScroll.Item = ContinuousScrollItem;
ContinuousScroll.defaultProps = defaultProps;